import { render, staticRenderFns } from "./TemplateEditorDrawer.vue?vue&type=template&id=223250b5&scoped=true"
import script from "./TemplateEditorDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateEditorDrawer.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditorDrawer.vue?vue&type=style&index=0&id=223250b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223250b5",
  null
  
)

export default component.exports